// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-ab2b","or":"styles_or__t69P7","forgot_button":"styles_forgot_button__lNbmT","form":"styles_form__ZZCjG"};